import * as React from 'react';

import styles from './AllServices.css';

interface IAllServicesProps {
  leftColumn: JSX.Element[];
  rightColumn: JSX.Element[];
}

export const AllServices: React.FC<IAllServicesProps> = ({ leftColumn, rightColumn }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['column']}>{leftColumn}</div>
      <div className={styles['column']}>{rightColumn}</div>
    </div>
  );
};
